<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <aHeader></aHeader>
    <div class="context">
      <router-view/>
    </div>
    <aFooter></aFooter>
    <!-- <aFooter v-if="$i18n.locale=='zh'"></aFooter> -->
    <!-- <aFooteren v-else></aFooteren> -->
  </div>
</template>
<script>
import aHeader from '@/components/aHeader.vue';
import aFooter from '@/components/aFooter.vue';
import aFooteren from '@/components/aFooteren.vue';
export default {
  name: 'App',
  components: {
    aHeader,
    aFooter,
    aFooteren
  },
};  
</script>
<style lang="scss">
@font-face {
  font-family: "Inter";
  src: url("~@/assets/fonts/Inter-Regular-9.otf");
}
#app {
  font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
}
.context{
  flex: 1;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
